<template>
    <div class="container-print">
        <div class="print-empty-wrap" style="display: flex; justify-content: center; align-items: center; flex-direction: column;"
            :style="{ minHeight: emptyMinHeight }">
            <div class="print-btn">
                <i class="el-icon-printer" style="font-size: 66px;"></i>
            </div>
            <div v-if="printList.length == 0" style="margin-top: 30px;">准考证打印时间未开放，敬请等待!</div>
            <div v-else style="margin-top: 30px;">准考证已生成，请下载打印!</div>
        </div>
        <div v-if="printList.length > 0" style="color: #A40000;font-size: 16px;font-weight: bold;margin: 100px 0 10px">
            相关下载附件</div>
        <div v-for="item in printList" :key="item.ticketType + '-' + item.registrationId"
            class="download-item" @click="handleDownload(item)">
            <i class="el-icon-folder-opened" style="font-size: 18px"></i>
            <div class="download-name">{{ ticketFileName(item) }}</div>
            <el-tag size="mini" :type="item.ticketType === 2 ? 'warning' : ''" style="margin-left: 8px;">
                {{ item.ticketType === 2 ? item.psyStageName : "笔试" }}
            </el-tag>
            <div class="download-actions">
                <el-button type="text" size="mini" @click.stop="handlePreview(item)">预览</el-button>
                <el-button type="text" size="mini" @click.stop="handleDownload(item)">下载</el-button>
            </div>
        </div>
        <!-- 考生端内嵌预览：PDF 以 blob 方式交给浏览器内置阅读器渲染 -->
        <div v-if="previewUrl" class="pdf-preview">
            <div class="pdf-preview-header">
                <span>文件预览</span>
                <el-button type="text" size="mini" @click="revokePreview">关闭预览</el-button>
            </div>
            <div v-loading="previewLoading">
                <iframe :src="previewUrl" class="pdf-frame"></iframe>
            </div>
            <div class="pdf-tip">若预览为空白（部分手机浏览器不支持），请点击「下载」用本地 PDF 阅读器打开。</div>
        </div>
    </div>
</template>

<script>
import * as ExamApi from "@/api/exam/index";
export default {
    data() {
        return {
            printList: [],
            previewUrl: "",
            previewLoading: false,
            activeKey: "",
        }
    },
    computed: {
        emptyMinHeight() {
            if (this.printList.length > 0) return 'auto';
            return window.innerWidth <= 768 ? 'calc(100vh - 260px)' : 'calc(100vh - 190px)';
        }
    },
    created() {
        // this.$nextTick(() => {
        this.getPrintData();
        // });
    },
    methods: {
        // 同时加载「笔试准考证」与「心理测试准考证」两类，用 ticketType 区分（1 笔试 / 2 心理测试）；
        // 两个接口各自独立容错，其中一个未发布（接口返回空/报错）不影响另一个的展示
        async getPrintData() {
            const examId = this.$store.state.exam.currentExamId;
            const [writtenList, psyList] = await Promise.all([
                ExamApi.getPrintList({ examId }).catch(() => []),
                ExamApi.getPsyPrintList({ examId }).catch(() => []),
            ]);
            const written = (Array.isArray(writtenList) ? writtenList : []).map((item) => ({
                ...item,
                ticketType: 1,
            }));
            const psy = (Array.isArray(psyList) ? psyList : []).map((item) => ({
                ...item,
                ticketType: 2,
            }));
            // 心理测试准考证排在前面（考生当前阶段更关注它）
            this.printList = [...psy, ...written];
            // 默认预览第一份，考生打开页面即可看到准考证
            if (this.printList.length) {
                this.handlePreview(this.printList[0]);
            }
        },
        ticketFileName(item) {
            // 笔试准考证也带上「笔试」，与心理测试准考证并排时一眼能分清；心理测试名称取考试配置
            const stageName = item.ticketType === 2 ? item.psyStageName : "笔试";
            return `${stageName}准考证-${item.examName}.pdf`;
        },
        itemKey(item) {
            return `${item.ticketType}-${item.registrationId}`;
        },
        // 下载接口统一返回 PDF 字节流，预览与下载共用同一次请求逻辑
        requestBlob(item) {
            const request = item.ticketType === 2
                ? ExamApi.downloadPsyTicket({ examId: item.examId })
                : ExamApi.downloadTicket({ examId: item.examId });
            return request.then((res) => new Blob([res], { type: "application/pdf" }));
        },
        // 预览：把 PDF 转成 blob URL 交给 iframe 渲染
        async handlePreview(item) {
            const key = this.itemKey(item);
            if (this.activeKey === key && this.previewUrl) return;
            this.previewLoading = true;
            try {
                const blob = await this.requestBlob(item);
                this.revokePreview();
                this.previewUrl = window.URL.createObjectURL(blob);
                this.activeKey = key;
            } catch (error) {
                console.error("预览失败:", error);
                this.$message.error("预览加载失败，请点击下载后查看");
            } finally {
                this.previewLoading = false;
            }
        },
        revokePreview() {
            if (this.previewUrl) {
                window.URL.revokeObjectURL(this.previewUrl);
                this.previewUrl = "";
                this.activeKey = "";
            }
        },
        handleDownload(item) {
            this.requestBlob(item).then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = this.ticketFileName(item);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }).catch((error) => {
                console.error("下载失败:", error);
            });
        },
    },
    beforeDestroy() {
        this.revokePreview();
    },
}
</script>

<style scoped lang="scss">
.container-print {
    padding: 30px;
    width: 90%;
}

.print-btn {
    width: 88px;
    height: 88px;
    background: #f5f7fa;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.download-item {
    color: #1989fa;
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    cursor: pointer;
}

.download-name {
    font-size: 16px;
}

.download-actions {
    margin-left: auto;
}

.pdf-preview {
    margin-top: 20px;
}

.pdf-preview-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    color: #303133;
    font-size: 16px;
    font-weight: bold;
}

.pdf-frame {
    width: 100%;
    height: 78vh;
    border: 1px solid #ebeef5;
    background: #f5f7fa;
}

.pdf-tip {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
}

/* 手机端适配 */
@media screen and (max-width: 768px) {
    .container-print {
        padding: 20px 16px;
        width: 100%;
        box-sizing: border-box;
    }

    .print-btn {
        width: 72px;
        height: 72px;

        i {
            font-size: 48px !important;
        }
    }

    .download-actions {
        margin-left: 0;
    }

    .pdf-frame {
        height: 60vh;
    }
}
</style>